import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BarChartIcon from '@mui/icons-material/BarChart';

const NAVY = '#011838';
const BLUE = '#003E87';
const GOLD = '#FDC500';

const categories = [
    {
        id: 'Gerenciar',
        children: [
            { id: 'Dashboard', icon: <BarChartIcon fontSize="small" />, route: '/painel' },
            { id: 'Respostas Ouvidoria', icon: <TableRowsIcon fontSize="small" />, route: '/resp-ouvidoria' },
        ],
    },
    {
        id: 'Administrador',
        children: [
            { id: 'Configurações', icon: <ManageAccountsIcon fontSize="small" />, route: '/config' },
        ],
    },
];

export default function Navigator(props) {
    const { ...other } = props;
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Drawer
            variant="permanent"
            {...other}
            sx={{ width: 256, flexShrink: 0 }}
        >
            <List disablePadding sx={{ bgcolor: NAVY, minHeight: '100vh' }}>
                {/* Brand header */}
                <ListItem
                    sx={{
                        py: 2.5,
                        px: 3,
                        borderBottom: `1px solid rgba(255,255,255,0.08)`,
                        justifyContent: 'center',
                    }}
                >
                    <Box
                        component="img"
                        src="/logo.png"
                        alt="Logo"
                        sx={{
                            maxWidth: '100%',
                            width: 160,
                            height: 'auto',
                            display: 'block',
                            mx: 'auto',
                        }}
                    />
                </ListItem>

                {/* Menu categories */}
                {categories.map(({ id, children }) => (
                    <Box key={id}>
                        <Typography
                            sx={{
                                px: 3,
                                pt: 2.5,
                                pb: 0.75,
                                fontSize: 10,
                                fontWeight: 700,
                                letterSpacing: 1.5,
                                textTransform: 'uppercase',
                                color: 'rgba(255,255,255,0.35)',
                            }}
                        >
                            {id}
                        </Typography>
                        {children.map(({ id: childId, icon, route }) => {
                            const isActive = location.pathname === route;
                            return (
                                <ListItem disablePadding key={childId} sx={{ px: 1.5, mb: 0.25 }}>
                                    <ListItemButton
                                        onClick={() => navigate(route)}
                                        sx={{
                                            borderRadius: 1.5,
                                            py: 1,
                                            px: 1.5,
                                            bgcolor: isActive ? BLUE : 'transparent',
                                            borderLeft: isActive ? `3px solid ${GOLD}` : '3px solid transparent',
                                            color: isActive ? '#fff' : 'rgba(255,255,255,0.6)',
                                            '&:hover': {
                                                bgcolor: isActive ? BLUE : 'rgba(255,255,255,0.07)',
                                                color: '#fff',
                                            },
                                            transition: 'all 0.15s',
                                        }}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                color: isActive ? GOLD : 'rgba(255,255,255,0.5)',
                                                minWidth: 34,
                                            }}
                                        >
                                            {icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={childId}
                                            primaryTypographyProps={{ fontSize: 13, fontWeight: isActive ? 600 : 400 }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                        <Divider sx={{ mt: 1.5, borderColor: 'rgba(255,255,255,0.07)' }} />
                    </Box>
                ))}
            </List>
        </Drawer>
    );
}
